<div class="emergency-service-container" [class.is-open]="isContentVisible">
  <div class="header" (click)="toggleContent()">
    <h3>Notdienst Konditionen</h3>
    <span class="toggle-icon">{{ isContentVisible ? '-' : '+' }}</span>
  </div>
  <div class="content" *ngIf="isContentVisible">
    <div class="conditions">
      <h4>Allgemeine Regelungen:</h4>
      <ul>
        <li>Die An- und Abfahrt zum Einsatzort zählt vollständig als Arbeitszeit.</li>
        <li>Es wird grundsätzlich eine Notdienstpauschale von 50 € berechnet.</li>
        <li>Alle nachfolgend genannten Zuschläge beziehen sich auf den gesamten Rechnungsbetrag.</li>
      </ul>

      <h4>Zuschläge nach Einsatzzeit</h4>
      <p>(jeweils auf den gesamten Rechnungsbetrag)</p>

      <div class="surcharge-category">
        <h5>Montag bis Donnerstag:</h5>
        <ul>
          <li><strong>16:00 – 22:00 Uhr:</strong> 65% Zuschlag</li>
          <li><strong>22:00 – 06:00 Uhr:</strong> zusätzlich +50% Zuschlag<br>(= 65% + 50% = 115% Zuschlag)</li>
        </ul>
      </div>

      <div class="surcharge-category">
        <h5>Freitag:</h5>
        <ul>
          <li><strong>13:00 – 22:00 Uhr:</strong> 65% Zuschlag</li>
          <li><strong>22:00 – 06:00 Uhr:</strong> zusätzlich +50% Zuschlag<br>(= 65% + 50% = 115% Zuschlag)</li>
        </ul>
      </div>

      <div class="surcharge-category">
        <h5>Samstag:</h5>
        <ul>
          <li><strong>06:00 – 22:00 Uhr:</strong> 100% Zuschlag</li>
          <li><strong>22:00 – 06:00 Uhr:</strong> zusätzlich +50% Zuschlag<br>(= 100% + 50% = 150% Zuschlag)</li>
        </ul>
      </div>

      <div class="surcharge-category">
        <h5>Sonntag:</h5>
        <ul>
          <li><strong>06:00 – 22:00 Uhr:</strong> 150% Zuschlag</li>
          <li><strong>22:00 – 06:00 Uhr:</strong> zusätzlich +50% Zuschlag<br>(= 150% + 50% = 200% Zuschlag)</li>
        </ul>
      </div>

      <div class="surcharge-category">
        <h5>Feiertage:</h5>
        <ul>
          <li><strong>06:00 – 16:00 Uhr:</strong> 200% Zuschlag</li>
          <li><strong>16:00 – 06:00 Uhr:</strong> zusätzlich +50% Zuschlag<br>(= 200% + 50% = 250% Zuschlag)</li>
        </ul>
      </div>
    </div>
  </div>
</div>